import { Link } from "react-router-dom";

export default function Navbar({ dark, toggleTheme }) {
  return (
    <nav className="navbar">
      <div className="nav-left">
        <h2 className="logo">📬 E-Newsletter</h2>
        <Link to="/" className="nav-link">Create</Link>
        <Link to="/list" className="nav-link">Newsletters</Link>
        <Link to="/read" className="nav-link"> Read </Link>
      </div>

      <div className="nav-right">
        <button className="theme-btn" onClick={toggleTheme}>
          {dark ? "🌙 Dark" : "☀️ Light"}
        </button>
      </div>
    </nav>
  );
}

